import { SVGProps } from 'react';

const ArrowExpandIcon = ({ color = '#7A7A7A', size = 11, ...props }: SVGProps<SVGSVGElement> & { size?: number }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M0.75 5.41667L5.41667 0.75L10.0833 5.41667"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default ArrowExpandIcon;
